import { defineComponent as _defineComponent } from 'vue'
import { DataTable, HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { OrdersTableEmptyState } from './components/OrdersTableEmptyState';

import { columns } from './columns';
import { PortfolioOrder } from '@/modules/wealth/services/portfolio';
import { FetchOrdersStatus } from '@/modules/wealth/views/IndexPortfolio/components/Orders/types';

interface Props {
  orders: PortfolioOrder[];
  itemsPerPage: number;
  hasFilterSelected: boolean;
  status: FetchOrdersStatus;
}
interface Emit {
  (event: 'on-order-click', order: PortfolioOrder): void;
  (event: 'on-retry'): void;
  (event: 'on-clear-filters'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersTable',
  props: {
    orders: null,
    itemsPerPage: null,
    hasFilterSelected: { type: Boolean },
    status: null
  },
  emits: ["on-order-click", "on-retry", "on-clear-filters"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'on-order-click', order: PortfolioOrder): void;
  (event: 'on-retry'): void;
  (event: 'on-clear-filters'): void;
}), expose: any, slots: any, attrs: any }) {





const emitOnOrderClick = (order: PortfolioOrder) => {
  emit('on-order-click', order);
};

const emitOnClearFilters = () => {
  emit('on-clear-filters');
};

const emitOnRetry = () => {
  emit('on-retry');
};

return { __sfc: true,emit, emitOnOrderClick, emitOnClearFilters, emitOnRetry, DataTable, HelperViewStatus, OrdersTableEmptyState, columns }
}

})